import BaseApiCall from "./BaseApiCall";


export const loadMentorByOrg = async (orgId) => {
    try {
        const response = await BaseApiCall.get('/settings/load-mentor-by-org', { params: { orgId } }
        );
        return response.data;
    } catch (error) {
        console.error('Loading error:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const deptList = async () => {
    try {
        const response = await BaseApiCall.post('/settings/dept-list');
        return response;
    } catch (error) {
        console.error('Error loading dept:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const setDept = async (formData) => {
    try {
        const response = await BaseApiCall.post('/settings/new-dept', formData);
        return response;
    } catch (error) {
        console.error('Error creating department:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const setHead = async (formData) => {
    try {
        const response = await BaseApiCall.post('/settings/new-phead', formData);
        return response;
    } catch (error) {
        console.error('Error creating problem:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const headList = async (orgId) => {
    try {
        const response = await BaseApiCall.post('/settings/load-problem-heads', { orgId: orgId });
        return response;
    } catch (error) {
        console.error('Error loading dept:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const getTicketHead = async (headId) => {
    try {
        const response = await BaseApiCall.get(`/settings/get-ticket-head/${headId}`);
        return response.data;
    } catch (error) {
        console.error('Error loading dept:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const updateHead = async (headId, formData) => {
    try {
        const response = await BaseApiCall.put(`/settings/update-head/${headId}`, formData);
        return response;
    } catch (error) {
        console.error('Error loading dept:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
}; 

export const loadCategory = async (orgId) => {
    try {
        const response = await BaseApiCall.post('/settings/load-category', { orgId: orgId });
        return response;
    } catch (error) {
        console.error('Error loading dept:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};


export const setProblemCategory = async (formData) => {
    try {
        const response = await BaseApiCall.post('/settings/new-category', formData);
        return response;
    } catch (error) {
        console.error('Error creating category:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};


export const updateCategory = async (orgId) => {
    try {
        const response = await BaseApiCall.post('/settings/load-category', { orgId: orgId });
        return response;
    } catch (error) {
        console.error('Error loading dept:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const categoryDetails = async (id) => {
    try {
        const response = await BaseApiCall.post('/settings/get-category', { id: id });
        return response;
    } catch (error) {
        console.error('Error loading dept:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const loadPriority = async (organizationId) => {

    try {
        const response = await BaseApiCall.post('/admin-settings/load-ticket-priority', { organizationId: organizationId });
        return response;
    } catch (error) {
        console.error('Error loading dept:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const loadTicketStatus = async (organizationId) => {
    try {
        const response = await BaseApiCall.post('/admin-settings/load-ticket-status', { organizationId: organizationId });
        return response;
    } catch (error) {
        console.error('Error loading dept:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
};

export const addTicketPriority = async (formData) => {
    try {
        const response = await BaseApiCall.post('/admin-settings/new-ticket-priority', formData);
        return response;
    } catch (error) {
        console.error('Error loading dept:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
}

export const addTicketProgressStatus = async (formData) => {
    try {
        const response = await BaseApiCall.post('/admin-settings/new-ticket-progress-status', formData);
        return response;
    } catch (error) {
        console.error('Error loading dept:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
}

export const getFormFieldApiSettings = async (dyFormId, fieldName) => {
    try {
        const response = await BaseApiCall.get("/settings/field-api-settings", {
            params: { dyFormId, fieldName }
        });
        return response;
    } catch (error) {
        console.error('Loading error:', error.message);

        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }

        throw error;
    }
};

export const toggleUserStatus = async (userId) => {
    try {
        const response = await BaseApiCall.post(`/au/user/${userId}/toggle-status`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const changePassword = async (formData) => {
    try {
        const response = await BaseApiCall.post('/au/change-password', formData);
        return response;
    } catch (error) {
        console.error('Error loading dept:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
}

export const changeUserPassword = async (formData) => {
    try {
        const response = await BaseApiCall.post('/au/change-user-password', formData);
        return response;
    } catch (error) {
        console.error('Error loading dept:', error.message);
        if (error.response) {
            console.error('Response data:', error.response.data);
            console.error('Response status:', error.response.status);
        }
        throw error;
    }
}



